import React from 'react'

/* COMPONENTS */
import styled from 'styled-components'


const CardWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;

    label{
        font-family: "Poppins";
        font-weight: 400;
        font-style: normal;
        margin-bottom: 0.9rem;
    }


`
const InputEl = styled.select`
    font-family: "Poppins";
    font-weight: 500;
    font-size: 1rem;
    background-color: white;
    color: black;
    padding-left: 0.4rem;
    width: 420px;
    height: 45px;
    border:1px solid rgb(215, 215, 215);
    outline:none;
    border-radius: 5px;


    @media screen and (max-width:720px){
        width: 100%;
        
    }


`


const Select = ({ name, data, target, onChange, editValue,onBlur }) => {
    console.log(data)
    return (
        <CardWrapper>
            <label style={{ fontFamily: "Poppins" }}>{name}</label>
            <InputEl onChange={onChange} onBlur={onBlur}>
                <option style={{ fontFamily: "sans-serif" }}>{editValue ? editValue : "Selecione"}</option>

                {Array.isArray(data) &&
                    data
                        .filter(item => item[target] !== editValue) // Filtra os itens que não são iguais ao editValue
                        .map(item => (
                            <option key={item[target]} style={{ fontFamily: "sans-serif" }}>
                                {item[target]}
                            </option>
                        ))}


            </InputEl>
        </CardWrapper>
    )
}

export default Select